import { render, staticRenderFns } from "./DeckPalette.vue?vue&type=template&id=393d6b14"
import script from "./DeckPalette.vue?vue&type=script&lang=ts"
export * from "./DeckPalette.vue?vue&type=script&lang=ts"
import style0 from "./DeckPalette.vue?vue&type=style&index=0&id=393d6b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports